<template>
  <div class="row">
    <div class="col-12">
      <card class="responsive-card-table" >
        <div class="row justify-content-center align-items-center">
          <div class="col-12 col-lg-6 col-xl-4">
            <img src="https://www.italmotori.com/wp-content/uploads/2017/12/home-02.jpg" class="img-fluid m-auto d-block" alt="">
          </div>
          <div class="col-12 col-lg-6 col-xl-8">
            
            <h3>Benvenuto nel gestionale di ITALMOTORI</h3>
            <p>
              <b>Per cercare un cantiere</b>, usa la lente di ingrandimento in alto
            </p>
            <p>Puoi cercare anche direttamente un motore o un veicolo</p>
            <p>Per guardare la lista dei cantieri, apri il menù di sinistra e seleziona "cantieri"</p>

          </div>
        </div>
      </card>
    </div>
    
    <div 
      v-if="user.is('backoffice') || user.is('worker')"
      class="col-12">
      <h6> Revisioni tecniche non ancora spedite</h6>
      <card class="responsive-card-table">
        <div
          v-if="!loading"	
        > 
          <div
            v-if="revisions.length === 0">
            <h2 class="text-center">Nessuna revisione da inviare</h2>
          </div>
          <im-table 
            v-else
            :loading="loading"
            :model="revisions"
            :url="buildUrl"
            :layout="''"
            @getAll="search"
            @delete="deleteRequest">
            <template slot="columns">
              <el-table-column
                label="Data">
                <template slot-scope="scope">
                  {{scope.row.revisionDate | moment('DD/MM/YYYY')}}
                </template>
              </el-table-column>
              <el-table-column
                label="Cliente">
                <template slot-scope="scope">
                  <router-link 
                    class="text-info"
                    :to="`/sites/${scope.row.engine.site._id}`">
                    {{scope.row.engine.site.clientName}}
                  </router-link>
                </template>
              </el-table-column>
              <el-table-column
                label="Cantiere">
                <template slot-scope="scope">
                  <router-link 
                    class="text-info"
                    :to="`/sites/${scope.row.engine.site._id}`">
                    {{scope.row.engine.site.name}}
                  </router-link>
                </template>
              </el-table-column>
              <el-table-column
                label="Motore">
                <template slot-scope="scope">
                  <router-link 
                    class="text-info"
                    :to="`/sites/${scope.row.engine.site._id}/engines/${scope.row.engine._id}`">
                    {{scope.row.engine.name}} ({{scope.row.engine.registrationNumber}})
                  </router-link>
                </template>
              </el-table-column>
              <el-table-column
                v-if="user.is('backoffice')"
                label="Segna come inviata">
                <template slot-scope="scope">
                  <div class="btn btn-info" @click="checkAsSent(scope)">
                    <i class="tim-icons icon-check-2"></i>
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column
                prop="registrationNumber"
                label="Matricola" />
              <el-table-column
                prop="model"
                label="Veicolo" /> -->
            </template>
          </im-table>
        </div>
      </card>

      <div v-if="user.is('backoffice')">
        <h6> Lista revisioni effettuate</h6>
        <revisions-dashboard-list />
      </div>
    </div>  

  </div>
</template>
<script>

import swal from 'sweetalert2';
import { Table, TableColumn, Pagination } from 'element-ui'
import { mapState, mapActions } from 'vuex'
import RevisionsDashboardList from '../../components/Revisions/RevisionsDashboardList.vue';

export default {
  components: {
		[TableColumn.name]: TableColumn,
    RevisionsDashboardList
  },
  data() {
    return {
      env: process.env.VUE_APP_ENV,
    };
  },
  computed: {
    ...mapState({
      revisions: state => state.revisions.revisions,
      loading: state => state.revisions.loading,
      user: state => state.account.user,
    }),
  },
  methods: {
    ...mapActions('revisions', {
      getRevisions: 'getAllAll',
      deleteRevision: 'delete',
      updateRevision: 'update' 
    }),
    search() {
      let query = {
        technicalEmailSent: false
      }
      if ( this.user.is('worker')){
        query.author = this.user._id
      }
      this.getRevisions(query)
    },
    deleteRequest(scope) {
      this.deleteRevision({
        engineId: scope.row.engine._id,
        id: scope.row.id,
      })
    },
    async checkAsSent(scope) {
      const confirm = await swal.fire({
          title: 'Stai per segnare questa revisione come "inviata al cliente"',
          // text: "You won't be able to revert this!",
          type: 'danger',
          confirmButtonText: 'Confermo',
          showCancelButton: true,
          cancelButtonText: 'Annulla',
          reverseButtons: true
      })

      if (confirm.value) {
        this.updateRevision({
          id: scope.row.id,
          engine: scope.row.engine._id,
          technicalEmailSent: true
        })
      }
      setTimeout(this.search,500)
    },
		buildUrl(scope) {
			return `/engines/${scope.row.engine._id}/revisions/${scope.row.id}`
		},
  },
  mounted() {
    this.search()
  },
};
</script>
<style></style>
